import {
  type Country,
  getClassificationFromSiteName,
  getSiteNameFromCountryAndProduct,
  getZoneFromSite,
  type MelwaysZone,
  type SiteName,
} from '@seek/melways-sites';

export const getCountryFromSite = (site: SiteName): Country =>
  getClassificationFromSiteName(mapToMelwaysSiteName(site))?.country || 'au';

// Due to sku config providing "site" as a string ..
// .. we need to map it to the Melways SiteName type
export const mapToMelwaysSiteName = (site: string): SiteName =>
  site as SiteName;

export const getZoneFromCountry = (country: Country): MelwaysZone => {
  try {
    const siteName = getSiteNameFromCountryAndProduct({
      country,
      product: 'candidate',
    });
    const zone = getZoneFromSite(siteName);

    return zone;
  } catch {
    throw new Error('invalid/unsupported country');
  }
};
